import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '../../helpers'
import { toast } from 'react-toastify'
import { MergeRequest, MergeResponse } from '../../models/DocumentAudit/types'

export const useMerge = (leaseAuditId: number) => {
    const queryClient = useQueryClient()
    const deliverableQueryKey = ['deliverable', leaseAuditId] as const

    const {
        mutateAsync: mergeResidentTermDirectories,
        isLoading: isMerging,
    } = useMutation<MergeResponse, Error, MergeRequest>({
        mutationFn: async ({ merges }: MergeRequest) => {
            console.log('merges', merges)

            const response = await axiosInstance.post<MergeResponse>(
                `/document-audit/merge-transactions/`,
                {
                    lease_audit_id: leaseAuditId,
                    merges: merges,
                },
            )
            return response.data
        },
        onSuccess: () => {
            // Invalidate the deliverable query to refetch the data
            queryClient.invalidateQueries({ queryKey: deliverableQueryKey })
            toast.success('Merge completed successfully')
        },
        onError: (error) => {
            toast.error(`Error merging: ${error.message}`)
        },
    })

    return {
        mergeResidentTermDirectories,
        isMerging,
    }
}
